import { Action } from '@ngrx/store';

import { label } from '../../util';
import { ICobrandProgram } from '../../models/cobrand-model';

export const CobrandInfoActionTypes = {
	GET_COBRAND_INFO: label('[COBRAND_INFO] Get Cobrand Info'),
	GET_COBRAND_INFO_SUCCESS: label('[COBRAND_INFO] Get Cobrand Info Success'),
	GET_COBRAND_INFO_FAILURE: label('[COBRAND_INFO] Get Cobrand Info Error'),
	SKIP_COBRAND_INFO: label('[COBRAND_INFO] Skip Cobrand Info'),
};

export class GetCobrandInfo implements Action {
	type = CobrandInfoActionTypes.GET_COBRAND_INFO;
	constructor(public payload: { accountId: string }) { }
}

export class GetCobrandInfoSuccess implements Action {
	type = CobrandInfoActionTypes.GET_COBRAND_INFO_SUCCESS;
	constructor(public payload: ICobrandProgram) { }
}

export class GetCobrandInfoFailure implements Action {
	type = CobrandInfoActionTypes.GET_COBRAND_INFO_FAILURE;
	constructor(public payload: any) { }
}

export class SkipCobrandInfo implements Action {
	type = CobrandInfoActionTypes.SKIP_COBRAND_INFO;
}

export type CobranInfoActions =
	| GetCobrandInfo
	| GetCobrandInfoSuccess
	| GetCobrandInfoFailure
	| SkipCobrandInfo
